import React from 'react'

const FormDashboardInputControlled = ({className, ...props}) => {
  return (
    <input
      className={`rounded border py-2 px-4 text-sm ${className}`}
      style={{borderColor: '#ddd'}}
      {...props}
    />
  )
}

export { FormDashboardInputControlled }
